module.exports = __webpack_public_path__ + "static/media/shopify-dark.937412fd.svg";